// utils/toCsv.js
export const arrayToCsv = (rows) => {
    if (!rows?.length) return "";

    const header = Object.keys(rows[0]);
    const escape = (v) =>
      `"${String(v).replace(/"/g, '""')}"`;          // keep quotes safe

    const line = (obj) =>
      header.map((field) => escape(obj[field] ?? "")).join(",");

    return [header.join(","), ...rows.map(line)].join("\n");
  };
